/**
 * KeyboardShortcutsHelp Component
 *
 * Modal dialog showing all available keyboard shortcuts for the label editor.
 */

import { useTranslation } from 'react-i18next';
import { Keyboard } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';

export function KeyboardShortcutsHelp() {
  const { t } = useTranslation('settings');

  const shortcuts = [
    { keys: ['Ctrl', 'Z'], description: t('production.keyboardShortcuts.undo') },
    { keys: ['Ctrl', 'Shift', 'Z'], description: t('production.keyboardShortcuts.redo') },
    { keys: ['Arrow keys'], description: t('production.keyboardShortcuts.nudge1mm') },
    { keys: ['Shift', 'Arrow keys'], description: t('production.keyboardShortcuts.nudge5mm') },
    { keys: ['Delete'], description: t('production.keyboardShortcuts.hideComponent') },
    { keys: ['Escape'], description: t('production.keyboardShortcuts.deselect') },
    { keys: ['L'], description: t('production.keyboardShortcuts.toggleLock') },
    { keys: ['V'], description: t('production.keyboardShortcuts.toggleVisibility') },
  ];

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" title={t('production.editorToolbar.keyboardShortcutsTitle')}>
          <Keyboard className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('production.keyboardShortcuts.title')}</DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          {shortcuts.map((shortcut, i) => (
            <div
              key={i}
              className="flex items-center justify-between py-1.5 border-b border-border/50 last:border-0"
            >
              <span className="text-sm text-muted-foreground">{shortcut.description}</span>
              <div className="flex items-center gap-1">
                {shortcut.keys.map((key, j) => (
                  <kbd
                    key={j}
                    className="px-2 py-0.5 text-xs font-mono bg-muted rounded border shadow-sm"
                  >
                    {key}
                  </kbd>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
